import { useParams } from 'react-router-dom'
import { reject } from 'lodash-es'
import { useMutation } from '@tanstack/react-query'
import { useSnackbar } from '@ui/snackbar'
import { getProjectFiles, getProjectFilesTemplates } from '@queries'
import { deleteProjectFolder } from '@mutations'
import queryClient from 'src/state/client'

interface Options {
  onDeleteSuccess?: () => void
}

const useDeleteFolder = (rootGuid: string, options?: Options) => {
  const { projectId } = useParams()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation(
    async (folderId: string) => {
      return await deleteProjectFolder.request(projectId, rootGuid, folderId)
    },
    {
      onSuccess: (data: string[]) => {
        const getProjectFilesKey = getProjectFiles.getKey(projectId, rootGuid)

        queryClient.setQueryData<FilesResult>(getProjectFilesKey, prev => {
          if (!prev) return undefined

          const newFolders = reject(prev.sections, f => data.includes(f.guid))
          const newFiles = reject(prev.files, f => data.includes(f.guid))

          return {
            ...prev,
            sections: newFolders,
            files: newFiles,
          }
        })
        // Removed element files are offered as templates again
        queryClient.invalidateQueries(getProjectFilesTemplates.getKey(projectId, rootGuid))
        options?.onDeleteSuccess?.()
      },
      onError: () => {
        enqueueSnackbar('Fehler beim Löschen', { variant: 'error' })
      },
    },
  )
}

export default useDeleteFolder
